export default function Mission() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Noto Serif TC, serif' }}>
            我們的使命與承諾
          </h2>
          <p className="text-xl text-gray-600">讓每一場團建，都成為改變的起點</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-flag-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">我們的使命</h3>
            <p className="text-xl text-gray-700 leading-relaxed">
              讓團隊敢承諾、敢行動、敢承擔、敢突破。
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-hand-heart-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">我們的承諾</h3>
            <p className="text-xl text-gray-700 leading-relaxed">
              每一場團建，都要讓工作現場變得不一樣。不是感動三天，而是影響三年。
            </p>
          </div>
        </div>

        <div className="relative rounded-3xl overflow-hidden h-96 mb-12">
          <img
            src="https://public.readdy.ai/ai/img_res/93290d8c8c9da696eb1acaf2115b3e0b.jpg"
            alt="團隊承諾"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        </div>

        <div className="text-center">
          <p className="text-2xl md:text-3xl text-gray-700 leading-relaxed mb-4">
            我們要的不是<span className="font-bold text-gray-900">照片</span>，
          </p>
          <p className="text-2xl md:text-3xl text-gray-700 leading-relaxed mb-4">
            是<span className="font-bold text-gray-900">結果</span>。
          </p>
          <p className="text-2xl md:text-3xl text-gray-700 leading-relaxed">
            團建結束不是終點，而是<span className="font-bold text-gray-900">改變的起點</span>。
          </p>
        </div>
      </div>
    </section>
  );
}
